/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClientRole {
	Owner = 'Owner',
	Administrator = 'Administrator',
	Editor = 'Editor',
	Reviewer = 'Reviewer',
	LimitedAccess = 'LimitedAccess',
	Guest = 'Guest',
}
